// Iter 597 — Dashboard Performa Desain Bordir: 4 KPI + Riwayat Pekerjaan (pagination backend).
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { DesignPointsDialog } from "./bordir_design_points";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PRESETS = [["today", "Hari Ini"], ["yesterday", "Kemarin"], ["7d", "7 Hari"], ["30d", "30 Hari"], ["custom", "Pilih Tanggal"]];
const SCOPES = [["all", "Gabungan"], ["shopee", "Shopee"], ["offline", "Offline"]];

function Chips({ items, value, onChange, tid }) {
  return <div role="tablist" style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
    {items.map(([v, l]) => <button key={v} type="button" role="tab" aria-selected={value === v}
      className={`lb-chip sm${value === v ? " active" : ""}`} onClick={() => onChange(v)} data-testid={`${tid}-${v}`}>{l}</button>)}
  </div>;
}

function Kpi({ label, value, sub, tid }) {
  return <div className="op-stat" style={{ cursor: "default" }} data-testid={tid}>
    <span className="op-stat-label">{label}</span>
    <strong className="op-stat-value op-stat-value-plain" data-testid={`${tid}-value`}>{value ?? "–"}</strong>
    <span className="op-stat-sub">{sub}</span>
  </div>;
}

const fmt = (iso) => { try { return new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", dateStyle: "medium", timeStyle: "short" }); } catch { return iso || "-"; } };

const designsTitle = (r) => [...(r.designs || []).map(d => `${d.label}: ${d.titik} titik`),
  ...(r.corrections || []).map(c => `Koreksi ${fmt(c.at)} · ${c.by}${c.reason ? ` · ${c.reason}` : ""}: ${c.before ? c.before.total_titik : "-"} → ${c.after.total_titik} titik`)].join("\n");

function HistoryTable({ params, tid, onCorrected }) {
  const [q, setQ] = useState("");
  const [allTime, setAllTime] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [fix, setFix] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => { setPage(1); }, [params, q, allTime]);
  useEffect(() => {
    let alive = true;
    const t = setTimeout(async () => {
      try {
        const p = { ...params, page, page_size: 25, q, ...(allTime ? { preset: "all" } : {}) };
        const r = await axios.get(`${API}/shopee/embroidery/design-history`, { params: p, withCredentials: true, timeout: 20_000 });
        if (alive) { setData(r.data); setErr(""); }
      } catch (e) { if (alive) setErr(e?.response?.data?.detail || e.message || "Gagal memuat riwayat"); }
    }, 300);
    return () => { alive = false; clearTimeout(t); };
  }, [params, page, q, allTime, tick]);
  const openFix = (r) => setFix({ r, target: r.source === "shopee" ? { source: "shopee", job_id: r.job_id } : { source: "offline", order_number: r.order_number, product_id: r.job_id } });
  const saveFix = async (designs, reason) => {
    await axios.post(`${API}/shopee/embroidery/design-points/correct`, { ...fix.target, designs, reason }, { withCredentials: true });
    setFix(null); setTick(t => t + 1); onCorrected && onCorrected();
  };
  return <div data-testid={tid} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      <strong style={{ fontSize: 13 }}>Riwayat Pekerjaan</strong>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="Cari nomor nota / judul"
        style={{ padding: "6px 10px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 12, minWidth: 220 }} data-testid={`${tid}-search`} />
      <label className="muted small" style={{ display: "flex", gap: 4, alignItems: "center" }}>
        <input type="checkbox" checked={allTime} onChange={e => setAllTime(e.target.checked)} data-testid={`${tid}-all-time`} /> Semua riwayat
      </label>
      {data && <span className="muted small" data-testid={`${tid}-total`}>{data.total} pekerjaan</span>}
    </div>
    {err && <div className="warn-box small" data-testid={`${tid}-error`}>{err}</div>}
    <div style={{ overflowX: "auto" }}>
      <table className="data-table" style={{ width: "100%", fontSize: 12 }}>
        <thead><tr><th>Nota</th><th>Sumber</th><th>Pekerjaan</th><th>Desainer</th><th>Selesai Desain (WIB)</th><th>Desain</th><th>Titik</th><th>Revisi</th><th>Status Berikutnya</th>{data?.items?.[0]?.can_correct && <th></th>}</tr></thead>
        <tbody>
          {(data?.items || []).map(r => <tr key={r.key} data-testid={`${tid}-row-${r.key}`}>
            <td><b>{r.order_number}</b></td>
            <td>{r.source === "shopee" ? "Shopee" : "Offline"}</td>
            <td>{r.title || "-"}</td>
            <td>{r.designer_name}{r.designer_name_raw && r.designer_name === "Belum Teridentifikasi" ? <span className="muted"> ({r.designer_name_raw})</span> : null}</td>
            <td>{fmt(r.done_at)}</td>
            <td title={designsTitle(r)} data-testid={`${tid}-designs-${r.key}`}>{r.design_count}</td>
            <td title={designsTitle(r)} data-testid={`${tid}-titik-${r.key}`}>{r.has_points ? r.total_titik : <span className="muted">Belum tercatat</span>}{r.corrected ? <span className="muted"> · Dikoreksi</span> : null}</td>
            <td title={(r.revisions || []).map(v => `${fmt(v.at)} · ${v.designer_name}`).join("\n")}>{r.revision_count || 0}</td>
            <td>{r.next_status}</td>
            {r.can_correct && <td><button type="button" className="soft-btn small-btn" onClick={() => openFix(r)} data-testid={`${tid}-correct-${r.key}`}>Koreksi</button></td>}
          </tr>)}
          {data && data.items.length === 0 && <tr><td colSpan={10} className="muted" data-testid={`${tid}-empty`}>Belum ada pekerjaan pada periode ini.</td></tr>}
        </tbody>
      </table>
    </div>
    {data && data.pages > 1 && <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <button type="button" className="soft-btn small-btn" disabled={page <= 1} onClick={() => setPage(p => p - 1)} data-testid={`${tid}-prev`}>Sebelumnya</button>
      <span className="muted small" data-testid={`${tid}-page`}>Halaman {page} / {data.pages}</span>
      <button type="button" className="soft-btn small-btn" disabled={page >= data.pages} onClick={() => setPage(p => p + 1)} data-testid={`${tid}-next`}>Berikutnya</button>
    </div>}
    {fix && <DesignPointsDialog target={fix.target} mode="correct" label={`${fix.r.order_number} · ${fix.r.title || ""} · ${fix.r.designer_name}`}
      onSubmit={saveFix} onClose={() => setFix(null)} />}
  </div>;
}

export function DesainPerformaPanel({ testIdPrefix = "desain-performa" }) {
  const tid = testIdPrefix;
  const [preset, setPreset] = useState("today");
  const [scope, setScope] = useState("all");
  const [designer, setDesigner] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [hidden, setHidden] = useState(false);
  const ready = preset !== "custom" || (from && to);
  const params = React.useMemo(() => ({ preset, scope, designer_id: designer, ...(preset === "custom" ? { date_from: from, date_to: to } : {}) }),
    [preset, scope, designer, from, to]);
  const load = useCallback(async () => {
    if (!ready) return;
    try {
      const r = await axios.get(`${API}/shopee/embroidery/performance`, { params, withCredentials: true, timeout: 20_000 });
      setData(r.data); setErr("");
    } catch (e) {
      if (e?.response?.status === 403 && !designer) setHidden(true);
      else setErr(e?.response?.data?.detail || e.message || "Gagal memuat performa");
    }
  }, [params, ready, designer]);
  useEffect(() => { load(); }, [load]);
  if (hidden) return null;
  const k = data?.kpi || {};
  const label = PRESETS.find(p => p[0] === preset)?.[1];
  return <section className="leaderboard-bordir" data-testid={tid} style={{ borderRadius: 10, padding: "10px 12px", margin: "10px 0 14px", display: "flex", flexDirection: "column", gap: 10 }}>
    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
      <div>
        <h3 className="lb-title">Dashboard Performa Desain Bordir</h3>
        <p className="lb-sub">Dihitung sekali per pekerjaan · nota, desain & titik terpisah · WIB · {data?.period?.from ? `${data.period.from} s/d ${data.period.to}` : ""}</p>
      </div>
      {data?.can_choose_designer && <select value={designer} onChange={e => setDesigner(e.target.value)} data-testid={`${tid}-designer`}
        style={{ padding: "6px 8px", borderRadius: 6, border: "1px solid #cbd5e1", fontSize: 12 }}>
        <option value="">Semua desainer</option>
        {(data.designers || []).map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
        <option value="__unidentified__">Belum Teridentifikasi</option>
      </select>}
    </div>
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
      <Chips items={PRESETS} value={preset} onChange={setPreset} tid={`${tid}-period`} />
      <Chips items={SCOPES} value={scope} onChange={setScope} tid={`${tid}-scope`} />
      {preset === "custom" && <span style={{ display: "flex", gap: 4, alignItems: "center" }}>
        <input type="date" value={from} onChange={e => setFrom(e.target.value)} data-testid={`${tid}-from`} />
        <span className="muted small">s/d</span>
        <input type="date" value={to} onChange={e => setTo(e.target.value)} data-testid={`${tid}-to`} />
      </span>}
    </div>
    {err && <div className="warn-box small" data-testid={`${tid}-error`}>{err}</div>}
    <div className="op-stats-row" data-testid={`${tid}-kpi`}>
      <Kpi label="Sedang Dikerjakan" value={k.sedang_dikerjakan} sub="Saat ini" tid={`${tid}-kpi-sedang`} />
      <Kpi label="Selesai Hari Ini" value={k.selesai_hari_ini} sub="Desain selesai (WIB)" tid={`${tid}-kpi-hari-ini`} />
      <Kpi label={`Selesai · ${label}`} value={k.selesai_periode} sub={data ? `Shopee ${data.by_source.shopee} · Offline ${data.by_source.offline}` : ""} tid={`${tid}-kpi-periode`} />
      <Kpi label="Revisi" value={k.revisi} sub="Pekerjaan didesain ulang" tid={`${tid}-kpi-revisi`} />
    </div>
    <div className="op-stats-row" data-testid={`${tid}-kpi-titik-row`}>
      <Kpi label={`Total Nota · ${label}`} value={k.nota_periode} sub={`Hari ini ${k.nota_hari_ini ?? "–"}`} tid={`${tid}-kpi-nota`} />
      <Kpi label={`Jumlah Desain · ${label}`} value={k.desain_periode} sub={`Hari ini ${k.desain_hari_ini ?? "–"}`} tid={`${tid}-kpi-desain`} />
      <Kpi label={`Total Titik · ${label}`} value={k.titik_periode} sub={`Hari ini ${k.titik_hari_ini ?? "–"} · tidak dikali pcs`} tid={`${tid}-kpi-titik`} />
    </div>
    {k.tanpa_titik_periode > 0 && <div className="muted small" data-testid={`${tid}-tanpa-titik`}>
      {k.tanpa_titik_periode} pekerjaan lama belum punya catatan titik desain (dihitung 1 desain, titik belum tercatat). Owner/Admin dapat melengkapinya lewat tombol Koreksi.
    </div>}
    {data?.can_choose_designer && data.unidentified_periode > 0 && <div className="muted small" data-testid={`${tid}-unidentified`}>
      {data.unidentified_periode} pekerjaan pada periode ini belum teridentifikasi desainernya (data lama tanpa ID).
    </div>}
    {ready && <HistoryTable params={params} tid={`${tid}-history`} onCorrected={load} />}
  </section>;
}

export default DesainPerformaPanel;
